import { css } from '@emotion/css';
import type { FC } from 'react';

import { nonMobileMediaQuery, smallDesktopMediaQuery } from '../../../constants';
import { m } from '../../../motif';

export const lineBreakContainerCss = css`
  align-items: center;
  background-color: ${m('--bg-color')};
  display: flex;
  height: 100%;
  padding: ${m('--spacing-l')} ${m('--spacing-xl')};
  width: 100%;

  ${nonMobileMediaQuery} {
    padding: ${m('--spacing-l')} ${m('--spacing-xl')};
  }
  ${smallDesktopMediaQuery} {
    padding: ${m('--spacing-l')} ${m('--spacing-xxxl')};
  }
`;

export const lineBreakCss = css`
  background-color: ${m('--fg-color')};
  height: 1px;
  width: 100%;
`;

export const LineBreak: FC = () => {
  return (
    <div className={lineBreakContainerCss}>
      <div className={lineBreakCss} />
    </div>
  );
};
